import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-ai-interview-time-duration-popup',
  standalone: true,
  imports: [],
  templateUrl: './ai-interview-time-duration-popup.component.html',
  styleUrl: '../../globalStyle/limit-dialog-box-common.scss'
})
export class AiInterviewTimeDurationPopupComponent {

	constructor(
			private dialogRef: MatDialogRef<AiInterviewTimeDurationPopupComponent>,
			private router: Router
		) { }
	
		close() {
			this.dialogRef.close();
		}
	
		goToUpgradePlan() {
			this.router.navigate(['/student-dashboard/upgrade-plan']);
			this.close();
		}
}
